export const TRANSLATIONS = {
  // TODO: delete when it will be taken from events service - task 882
  EVENT_TYPE: {
    EB_EDUCATION: 'Vzdělávání',
    EB_EDUCATION_DESC: 'Vzdělávací aktivity a školení',

    EB_INDIRECT_WORK: 'Nepřímá práce',
    EB_INDIRECT_WORK_DESC: 'Práce, která nepřímo souvisí s hlavními úkoly',

    EB_AVAILABILITY: 'Dostupnost',
    EB_AVAILABILITY_DESC: 'Časy, kdy je pracovník k dispozici',

    EB_HOME_OFFICE: 'Práce z domova',
    EB_HOME_OFFICE_DESC: 'Práce vykonávaná z domova',

    EB_STANDBY: 'Pohotovost',
    EB_STANDBY_DESC: 'Čekání na případné nasazení',

    EB_SICKNESS: 'Nemoc',
    EB_SICKNESS_DESC: 'Nemocenská nebo pracovní neschopnost',

    EB_VACATION: 'Dovolená',
    EB_VACATION_DESC: 'Plánovaná dovolená',

    EB_PAID_LEAVE: 'Placené volno',
    EB_PAID_LEAVE_DESC: 'Nepracovní dny s náhradou mzdy',

    EB_UNPAID_LEAVE: 'Neplacené volno',
    EB_UNPAID_LEAVE_DESC: 'Nepracovní dny bez náhrady mzdy',

    EB_ASSISTANCE: 'Asistence',
    EB_ASSISTANCE_DESC: 'Poskytování asistence klientům',

    EB_SR_EVENT: 'SR událost',
    EB_SR_EVENT_DESC: 'Speciální SR událost',

    EB_SR_GROUP_EVENT: 'SR skupinová událost',
    EB_SR_GROUP_EVENT_DESC: 'Skupinová SR událost',

    EB_DAYCARE: 'Denní péče',
    EB_DAYCARE_DESC: 'Denní péče a programy',

    EB_TRANSIT: 'Přechod',
    EB_TRANSIT_DESC: 'Přechodné nebo transportní aktivity',

    EB_BASIC_SOCIAL_COUNSELING: 'Základní sociální poradenství',
    EB_BASIC_SOCIAL_COUNSELING_DESC: 'Poradenství a podpora klientům',

    EB_INTAKE: 'Přijímací proces',
    EB_INTAKE_DESC: 'Prvotní přijímání nových klientů',
  },
  FORMAT: {
    DATE: 'dd. MM. yyyy',
  },
  FORM: {
    VALIDATION: {
      REQUIRED: 'Pole je povinné',
      EMPTY_HTML: 'Pole nesmí být prázdné',
      EMAIL: 'Neplatný formát e-mailu',
      DEFAULT: 'Problém s vyplněnou hodnotou',
      ONLY_ONE_PRIMARY: 'Primární může být pouze jeden záznam',
      TIME_AFTER_START: 'Čas musí být po čase začátku',
      TIME_BETWEEN_TWO_TIMES: 'Čas musí být mezi časy začátku a konce',
      BIRTH_DATE_OR_NUMBER_REQUIRED: 'Datum narození nebo číslo je povinné',
      REQUIRED_LEVEL_PERCENTAGE_FOR_CONTRACT_TYPE: 'Pro daný typ smlouvy je pracovní úvazek povinný',
      REQUIRED_LEVEL_MONTHLY_HOURS_FOR_CONTRACT_TYPE: 'Pro daný typ smlouvy je maximální roční hodinový rozsah povinný',
      SUM_LEVEL_PERCENTAGE_EXCEEDS_FTE: 'Součet pracovních úvazků přesahuje celkový pracovní úvazek',
      SUM_LEVEL_MONTHLY_HOURS_EXCEEDS_LEVEL_OF_EMPLOYMENT_MONTHLY_HOURS:
        'Součet ročního hodinového rozsahu přesahuje celkový maximální roční hodinový rozsah',
    },
    LOADING_VALIDATION: 'Probíhá kontrola...',
    CHECK_FORM: 'Zkontrolujte formulář',
    ERROR_SAVE: 'Nastala chyba při ukládání formuláře',
    UNCHANGED_FORM: 'Formulář nezměněn, nebude odeslán',
  },
  WORK_POSITION_MODULE: {
    TITLE: 'Pracovní pozice',
    TABLE: {
      HEADERS: {
        DIVISION: 'Členění',
        NAME: 'Název pracovní pozice / aliasu',
        EXPORTABLE: 'Vykazatelné',
        ACTIONS: 'Akce',
      },
      NEW_TEMP_ALIAS_NAME: 'nový alias',
      ACTIONS_TOOLTIPS: {
        ADD: 'Vytvořit alias',
        DELETE: 'Smazat alias',
        DELETE_DISABLED: 'Nelze smazat, pracovní pozice musí obsahovat alespoň jeden alias',
      },
    },
    CRUD: {
      CREATE: {
        SUCCESS: 'Pozice byla vytvořena',
        ERROR: 'Nepodařilo se vytvořit pozici',
      },
      READ: {
        ERROR: 'Nepodařilo se načíst pracovní pozice',
      },
      UPDATE: {
        SUCCESS: 'Pozice byla aktualizována',
        ERROR: 'Nepodařilo se aktualizovat pozici',
      },
      DELETE: {
        SUCCESS: 'Pozice byla odstraněna',
        ERROR: 'Nepodařilo se odstranit pozici, ověřte, že ji žádný zaměstnanec nepoužívá ve smlouvě',
      },
    },
    DELETE_CONFIRM_DIALOG: {
      HEADER: 'Potvrzení smazání aliasu',
      MESSAGE: "Přejete si smazat alias '{{aliasName}}'?",
      BUTTONS: {
        ACCEPT: {
          LABEL: 'Smazat',
        },
        REJECT: {
          LABEL: 'Zrušit',
        },
      },
    },
    TOOLBAR: {
      BUTTONS: {
        EXPAND: {
          LABEL: 'Rozbalit vše',
        },
        COLLAPSE: {
          LABEL: 'Zabalit vše',
        },
      },
      SEARCH: {
        PLACEHOLDER: 'Vyhledat pracovní pozici',
      },
    },
  },
  WORK_DEPARTMENT_MODULE: {
    TITLE: 'Pracovní oddělení',
    TABLE: {
      COLUMNS: {
        LAST_NAME: 'Příjmení vedoucí/ho',
        FIRST_NAME: 'Jméno vedoucí/ho',
        NAME: 'Název',
        DESCRIPTION: 'Popis',
      },
      ACTIONS_TOOLTIPS: {
        ADD: 'Přidat pododdělení',
        EDIT: 'Upravit oddělení',
        DELETE: 'Smazat oddělení',
      },
      EMPTY_MESSAGE: 'Žádná oddělení nebyla nalezena.',
      CRUD: {
        READ: {
          ERROR: 'Nepodařilo se načíst oddělení',
        },
        DELETE: {
          SUCCESS: 'Oddělení bylo smazáno',
          ERROR: 'Nepodařilo se smazat oddělení',
        },
      },
    },
    MAIN_TOOLBAR: {
      BUTTONS: {
        CREATE: {
          LABEL: 'Přidat',
          TOOLTIP: 'Přidat hlavní oddělení',
        },
        EXPAND: { LABEL: 'Rozbalit vše' },
        COLLAPSE: { LABEL: 'Sbalit vše' },
      },
      SEARCH: {
        PLACEHOLDER: 'Hledat oddělení',
      },
    },
    FORM: {
      HEADERS: {
        CREATE: 'Nové oddělení',
        CREATE_SUB_DEPARTMENT: 'Nové pododdělení pro oddělení "{{parentName}}"',
        EDIT: 'Upravit oddělení',
      },
      FIELDS: {
        PARENT_WORK_DEPARTMENT: 'Nadřazené oddělení',
        NAME: 'Název',
        DESCRIPTION: 'Popis',
        LEADER: 'Vedoucí',
      },
      ACTIONS: {
        CANCEL: 'Zrušit',
        SAVE: 'Uložit',
      },
      CRUD: {
        CREATE: {
          SUCCESS: 'Oddělení bylo vytvořeno',
          ERROR: 'Nepodařilo se vytvořit oddělení',
        },
        READ: {
          ERROR: 'Nepodařilo se načíst oddělení',
        },
        UPDATE: {
          SUCCESS: 'Oddělení bylo upraveno',
          ERROR: 'Nepodařilo se upravit oddělení',
        },
      },
    },
    DELETE_CONFIRM_DIALOG: {
      HEADER: 'Potvrzení smazání',
      MESSAGE: "Opravdu chcete smazat oddělení '{{name}}'?",
      BUTTONS: {
        ACCEPT: {
          LABEL: 'Smazat',
        },
        CANCEL: {
          LABEL: 'Zrušit',
        },
      },
    },
  },
  COMMON: {
    SEARCH_LOCATION: 'Vyhledat lokaci',
    NO_RESULTS_FOUND: 'Žádné výsledky nebyly nalezeny',
    CLOSE: 'Zavřít',
    SOCIAL_SERVICE_PERMISSIONS: 'Oprávnění pro službu',
    SELECT_SERVICE_AND_LOCATION: 'Vyberte službu a lokaci',
    CHOSEN_SERVICE_AND_LOCATION: 'Vybraná lokace byla úspěšně změněna',
    FILTER_WORKERS_ONLY: 'Pouze pracovníci',
    FILTER_ROLES: 'Vyfiltrovat podle role',
    SEARCH: 'Vyhledávání',
    ADD_USER: 'Přidat uživatele',
    USER_MANAGEMENT: 'Uživatelé',
    ROLE: 'Role',
    TOOLTIP_ADD_USER: 'Přidat nového uživatele',
    TOOLTIP_SEARCH: 'Vyhledávání uživatelů',
    TOOLTIP_ROLE: 'Vyberte roli pro filtrování',
    TOOLTIP_LOCATION: 'Vyberte lokaci pro filtrování',
    TOOLTIP_EDIT: 'Upravit uživatele',
    TOOLTIP_DELETE: 'Smazat uživatele',
    LOCATION: 'Lokace',
    ONLY_WORKERS: 'Pouze pracovníci',
    EDIT_USER: 'Upravit uživatele',
    DELETE_USER: 'Smazat uživatele',
    DESCRIPTION: 'Popis',
    ENTRY: 'Zápis',
    TOUR_LOCATION_SELECT_CONTENT:
      'Zde si můžeš zvolit, ve které alokaci právě pracuješ.<br><br>Alokace odpovídají jednotlivým lokacím (pobočkám) v dané sociální službě. Tato volba ovlivňuje, s jakými daty budeš v aplikaci pracovat.<br><br>Pokud máš přístup jen k jedné alokaci, vybrali jsme ji automaticky.',
    TOUR_LOCATION_SELECT_TITLE: 'Výběr aktivní alokace',
    TOUR_UNDERSTAND_BUTTON: 'Rozumím',
    EMPTY_DATA_MESSAGE: 'Žádná data k zobrazení',
    TOAST: {
      EVENT_SAVED_SUCCESS: 'Událost úspěšně uložena',
      EVENT_SAVE_ERROR: 'Chyba při ukládání události',
      EVENT_DELETED_SUCCESS: 'Událost úspěšně smazána',
      EVENT_DELETE_ERROR: 'Chyba při mazání události',
      NOT_AUTHORIZED: 'Nemáte oprávnění pro tuto sekci',
      SEND_ASSISTANCE_OVERVIEW_CANNOT_SEND:
        'Nelze odeslat: u klienta chybí kontaktní údaje nebo přehled není připraven.',
      SEND_ASSISTANCE_OVERVIEW_SUCCESS: 'Přehled asistencí byl úspěšně odeslán.',
    },
    CANCEL: 'Zrušit',
    DELETE: 'Smazat',
    OK: 'OK',
    SAVE: 'Uložit',
    PROCEED: 'Pokračovat',
    LOADING: 'Načítání...',
    YES: 'Ano',
    NO: 'Ne',
    SEND_ASSISTANCE_OVERVIEW: 'Zaslat přehled asistencí',
  },
  TOAST: {
    SUCCESS: 'Úspěch',
    ERROR: 'Chyba',
    INFO: 'Info',
    WARN: 'Upozornění',
  },
  DELETE_CONFIRM_DIALOG: {
    HEADER: 'Potvrzení smazání záznamu',
    BUTTONS: {
      ACCEPT: {
        LABEL: 'Smazat',
      },
      REJECT: {
        LABEL: 'Zrušit',
      },
    },
  },
  UNSAVED_CHANGES_DIALOG: {
    HEADER: 'Máte neuložené změny',
    MESSAGE: 'Před opuštěním stránky si prosím zkontrolujte formulář.',
    BUTTONS: {
      ACCEPT: {
        LABEL: 'Uložit a odejít',
      },
      REJECT: {
        LABEL: 'Neukládat a odejít',
      },
    },
  },
  WORK_PROJECT_MODULE: {
    TITLE: 'Projekty',
    TABLE_VIEW: {
      MAIN_TOOLBAR: {
        BUTTONS: {
          CREATE: {
            LABEL: 'Přidat',
            TOOLTIP: 'Přidat nový projekt',
          },
        },
      },
      TABLE: {
        ACTIONS_TOOLTIPS: {
          EDIT: 'Upravit',
          DELETE: 'Smazat',
        },
        HEADERS: {
          NAME: 'Název',
          DESCRIPTION: 'Popis',
        },
      },
      CRUD: {
        READ: {
          REMOVE: 'Nepovedlo se načíst projekty',
        },
      },
    },
    DELETE_CONFIRM_DIALOG: {
      HEADER: 'Potvrzení smazání projektu',
      MESSAGE: "Přejete si smazat projekt '{{workProjectName}}'?",
      BUTTONS: {
        ACCEPT: {
          LABEL: 'Smazat',
        },
        REJECT: {
          LABEL: 'Zrušit',
        },
      },
      CRUD: {
        DELETE: {
          SUCCESS: 'Projekt byl smazán',
          REMOVE: 'Nepovedlo se smazat projekt',
        },
      },
    },
    FORM: {
      CREATE: {
        TITLE: 'Vytvořit projekt',
        ACTIONS: {
          CANCEL: 'Zrušit',
          SAVE: 'Vytvořit',
        },
      },
      EDIT: {
        TITLE: 'Upravit projekt',
        ACTIONS: {
          CANCEL: 'Zrušit',
          SAVE: 'Uložit',
        },
      },
      FIELDS: {
        NAME: 'Název',
        DESCRIPTION: 'Popis',
      },
      CRUD: {
        READ: {
          ERROR: 'Nepovedlo se načíst projekt',
        },
        UPDATE: {
          SUCCESS: 'Projekt byl uložen',
          ERROR: 'Nepovedlo se uložit projekt',
        },
        CREATE: {
          SUCCESS: 'Projekt byl vytvořen',
          ERROR: 'Nepovedlo se vytvořit projekt',
        },
      },
    },
  },
  DAYS_OF_WEEK_SHORTEN: {
    mon: 'Po',
    tue: 'Út',
    wed: 'St',
    thu: 'Čt',
    fri: 'Pá',
    sat: 'So',
    sun: 'Ne',
  },
  DAYS_OF_WEEK_FULL: {
    mon: 'Pondělí',
    tue: 'Úterý',
    wed: 'Středa',
    thu: 'Čtvrtek',
    fri: 'Pátek',
    sat: 'Sobota',
    sun: 'Neděle',
  },
  EMPLOYEE_MODULE: {
    TITLE: 'Zaměstnanci',
    CREATE_EMPLOYEE: {
      TITLE: 'Vytvořit zaměstnance',
      ACTIONS: {
        CANCEL: 'Zrušit',
        SAVE: 'Vytvořit',
      },
      FIELDS: {
        FIRST_NAME: 'Jméno',
        LAST_NAME: 'Příjmení',
      },
    },
    OKSYSTEM_EXPORT: {
      TITLE: 'Exportovat XML pro MPSV',
      ACTIONS: {
        CANCEL: 'Zrušit',
        SAVE: 'Exportovat',
      },
      FIELDS: {
        YEAR: 'Rok exportu',
      },
      CRUD: {
        READ: {
          ERROR: 'Nepodařilo se vyexportovat zaměstnance pro vybraný rok',
        },
      },
    },
    TABLE_VIEW: {
      MAIN_TOOLBAR: {
        BUTTONS: {
          CREATE: {
            LABEL: 'Přidat',
            TOOLTIP: 'Přidat nového zaměstnance',
          },
          OKSYSTEM_EXPORT: {
            LABEL: 'Exportovat XML pro MPSV',
            TOOLTIP: 'Exportovat tabulku do XML pro MPSV roční hlášení',
          },
          EXCEL_EXPORT: {
            LABEL: 'Exportovat',
            TOOLTIP: 'Exportovat tabulku do excelu',
          },
        },
      },
      SELECT_TOOLBAR: {
        TEXT: 'Vybráno záznamů: {{selectedItemsCount}}',
        BUTTONS: {
          EXCEL_EXPORT: {
            LABEL: 'Exportovat',
            TOOLTIP: 'Exportovat vybrané záznamy do excelu',
          },
          DEACTIVATE: {
            LABEL: 'Deaktivovat',
            TOOLTIP: 'Deaktivovat vybrané záznamy',
          },
        },
      },
      TABLE: {
        HEADERS: {
          LAST_NAME: 'Příjmení',
          FIRST_NAME: 'Jméno',
          PRIMARY_PHONE_NUMBER: 'Primární telefon',
          PRIMARY_EMAIL: 'Primární e-mail',
          BIRTH_DATE: 'Datum narození',
          UPCOMING_CONTRACT_VALID_FROM: 'Nadcházející smlouva - začátek',
          UPCOMING_CONTRACT_VALID_TO: 'Nadcházející smlouva - konec',
          UPCOMING_CONTRACT_TYPE: 'Nadcházející smlouva - typ',
          UPCOMING_CONTRACT_POSITION: 'Nadcházející smlouva - pozice',
          ACTIVE_CONTRACT_VALID_FROM: 'Aktivní smlouva - začátek',
          ACTIVE_CONTRACT_VALID_TO: 'Aktivní smlouva - konec',
          ACTIVE_CONTRACT_TYPE: 'Aktivní smlouva - typ',
          ACTIVE_CONTRACT_POSITION: 'Aktivní smlouva - pozice',
          ACTIVE_CONTRACT_TRIAL_PERIOD_END_DATE: 'Aktivní smlouva - konec zkušební doby',
          PAST_CONTRACT_VALID_FROM: 'Bývalá smlouva - začátek',
          PAST_CONTRACT_VALID_TO: 'Bývalá smlouva - konec',
          PAST_CONTRACT_TYPE: 'Bývalá smlouva - typ',
          PAST_CONTRACT_POSITION: 'Bývalá smlouva - pozice',
          MD_RD_START_DATE: 'Nástup na MD/RD',
          MD_RD_END_DATE: 'Konec MD/RD',
          ACTIONS: 'Akce',
        },
        ACTIONS_TOOLTIPS: { VIEW: 'Přejít na detail zaměstnance', DEACTIVATE: 'Deaktivovat zaměstnance' },
        COPY_PHONES: {
          TOOLTIP: 'Zkopírovat tel. čísla',
          TOAST: 'Telefonní čísla byla zkopírovány do schránky',
        },
        COPY_EMAILS: {
          TOOLTIP: 'Zkopírovat e-maily',
          TOAST: 'E-maily byly zkopírovány do schránky',
        },
      },
      EXPORT: {
        FILE_NAME: 'Zaměstnanci',
      },
    },
    DETAIL: {
      TITLE: 'Zaměstnanec',
      CRUD: {
        CREATE: {
          SUCCESS: 'Zaměstnanec byl vytvořen',
          ERROR: 'Nepodařilo se vytvořit zaměstnance',
        },
        READ: {
          ERROR: 'Nepodařilo se načíst zaměstnance',
        },
        UPDATE: {
          SUCCESS: 'Zaměstnanec byl aktualizován',
          ERROR: 'Nepodařilo se aktualizovat zaměstnance',
        },
      },
      TOOLBAR: {
        BUTTONS: {
          SAVE: {
            LABEL: 'Uložit',
            TOOLTIP: 'Uložit změny zaměstnance',
          },
        },
        NAVIGATION: {
          TITLE: 'Navigace v detailu zaměstnance',
        },
      },
      TABS: {
        BASIC: {
          TAB: {
            TITLE: 'Obecné',
          },
          SECTIONS: {
            GENERAL: {
              TITLE: 'Základní údaje',
              FIELDS: {
                TITLE: 'Titul',
                FIRST_NAME: 'Jméno',
                LAST_NAME: 'Příjmení',
                BIRTH_LAST_NAME: 'Rodné příjmení',
                OTHER_LAST_NAMES: 'Další příjmení',
                GENDER: 'Pohlaví',
                MARITAL_STATUS: 'Rodinný stav',
                BIRTH_DATE: 'Datum narození',
                PLACE_OF_BIRTH: 'Místo narození',
                BIRTH_NUMBER: 'Rodné číslo',
                HEALTH_INSURANCE: 'Zdravotní pojištovna',
              },
            },
            NATIONALITY: {
              TITLE: 'Státní příslušnost',
              FIELDS: {
                NATIONALITY: 'Národnost',
                ID_CARD_NUMBER: 'Číslo občanského průkazu',
                PASSPORT_NUMBER: 'Číslo pasu',
                TEMPORARY_RESIDENCE_PERMIT_START_DATE: 'Začátek dočasného pobytu',
                TEMPORARY_RESIDENCE_PERMIT_END_DATE: 'Konec dočasného pobytu',
                BLUE_CARD_START_DATE: 'Začátek modré karty',
                BLUE_CARD_END_DATE: 'Konec modré karty',
                EMPLOYEE_CARD_START_DATE: 'Začátek zaměstnanecké karty',
                EMPLOYEE_CARD_END_DATE: 'Konec zaměstnanecké karty',
              },
            },
          },
        },
        CONTACT: {
          TAB: {
            TITLE: 'Kontaktní',
          },
          SECTIONS: {
            PERMANENT_ADDRESS: {
              TITLE: 'Trvalá adresa',
              FIELDS: {
                STREET_NAME: 'Ulice',
                HOUSE_NUMBER: 'Číslo popisné/číslo orientační',
                CITY: 'Obec',
                POST_CODE: 'PSČ',
              },
            },
            CONTACT_ADDRESS: {
              TITLE: 'Kontaktní adresa',
              FIELDS: {
                IS_CONTACT_ADDRESS_SAME_AS_PERMANENT_ADDRESS: 'Stejná jako trvalá adresa',
                STREET_NAME: 'Ulice',
                HOUSE_NUMBER: 'Číslo popisné/číslo orientační',
                CITY: 'Obec',
                POST_CODE: 'PSČ',
              },
            },
            PHONE: {
              TITLE: 'Telefonní kontakty',
              FIELDS: {
                COUNTRY_CODE: 'Předvolba',
                PHONE_NUMBER: 'Telefonní číslo',
                NOTE: 'Poznámka',
                IS_PRIMARY: 'Primární',
              },
              TABLE: {
                REMOVE: {
                  TOOLTIP: 'Odstranit telefonní kontakt',
                  MESSAGE: "Opravdu chcete odstranit telefonní kontakt '{{value}}'?",
                },
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat telefonní kontakt',
                },
              },
            },
            EMAIL: {
              TITLE: 'E-Mailové kontakty',
              FIELDS: {
                EMAIL: 'E-mail',
                NOTE: 'Poznámka',
                IS_PRIMARY: 'Primární',
              },
              TABLE: {
                REMOVE: {
                  TOOLTIP: 'Odstranit e-mailový kontakt',
                  MESSAGE: "Opravdu chcete odstranit e-mailový kontakt '{{value}}'?",
                },
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat e-mailový kontakt',
                },
              },
            },
            OTHER_CONTACT: {
              TITLE: 'Jiné kontakty',
              FIELDS: {
                CONTACT: 'Kontakt',
                NOTE: 'Poznámka',
              },
              TABLE: {
                REMOVE: {
                  TOOLTIP: 'Odstranit jiný kontakt',
                  MESSAGE: "Opravdu chcete odstranit jiný kontakt '{{value}}'?",
                },
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat jiný kontakt',
                },
              },
            },
            EMERGENCY_CONTACT: {
              TITLE: 'Nouzové kontakty',
              FIELDS: {
                COUNTRY_CODE: 'Předvolba',
                PHONE_NUMBER: 'Telefonní číslo',
                EMAIL: 'E-mail',
                NOTE: 'Poznámka',
                RELATIONSHIP: 'Vztah',
                IS_PRIMARY: 'Primární',
              },
              TABLE: {
                REMOVE: {
                  TOOLTIP: 'Odstranit nouzový kontakt',
                  MESSAGE: "Opravdu chcete odstranit nouzový kontakt '{{value}}'?",
                },
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat nouzový kontakt',
                },
              },
            },
            BANK: {
              TITLE: 'Bankovní spojení',
              FIELDS: {
                ACCOUNT_NUMBER: 'Číslo účtu',
                ACCOUNT_BANK_CODE: 'Kód banky',
              },
            },
          },
        },
        CONTRACTS: {
          TAB: {
            TITLE: 'Pracovní',
            LABELS: {
              ACTIVE: 'Aktivní',
              ARCHIVE: 'Archiv',
            },
          },
          TABLE: {
            COLUMNS: {
              CONTRACT_TYPE: 'Typ pracovního poměru',
              WORK_POSITION: 'Pracovní pozice',
              WORK_DEPARTMENT: 'Pracovní oddělení',
              VALID_FROM: 'Začátek smlouvy',
              VALID_TO: 'Konec smlouvy',
              FTE: 'Pracovní úvazek',
              LEVEL_OF_EMPLOYMENT_MONTHLY_HOURS: 'Maximální roční hodinový rozsah',
              TERMINATION_DATE: 'Datum ukončení pracovně právního vztahu',
            },
            ACTIONS_TOOLTIPS: {
              VIEW: 'Zobrazit smlouvu',
              CLONE: 'Duplikovat smlouvu',
              DELETE: 'Smazat smlouvu',
            },
            EMPTY: 'Nenalezeny žádné smlouvy',
            TOOLBAR: {
              BUTTONS: {
                CREATE: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat novou smlouvu',
                },
              },
            },
          },
          DELETE_CONFIRM_DIALOG: {
            HEADER: 'Potvrzení smazání smlouvy',
            MESSAGE: "Přejete si smazat smlouvu '{{contractLabel}}'?",
            BUTTONS: {
              ACCEPT: {
                LABEL: 'Smazat',
              },
              REJECT: {
                LABEL: 'Zrušit',
              },
            },
            CRUD: {
              DELETE: {
                SUCCESS: 'Smlouva byla odstraněna',
                ERROR: 'Nepodařilo se odstranit smlouvu',
              },
            },
          },
          CREATE_FORM: {
            TITLE: 'Přidat pracovní smlouvu',
            FIELDS: {
              CONTRACT_TYPE: 'Typ pracovního poměru',
              VALID_FROM: 'Začátek smlouvy',
              VALID_TO: 'Konec smlouvy',
              FTE: 'Pracovní úvazek',
              LEVEL_OF_EMPLOYMENT_MONTHLY_HOURS: 'Maximální roční hodinový rozsah',
              WORK_POSITION: 'Pracovní pozice',
            },
            ACTIONS: {
              CANCEL: 'Zrušit',
              SAVE: 'Uložit',
            },
            CRUD: {
              CREATE: {
                SUCCESS: 'Pracovní smlouva byla úspěšně vytvořena',
                ERROR: 'Nepodařilo se vytvořit pracovní smlouvu',
              },
            },
          },
          FORM: {
            SECTIONS: {
              CONTRACT_DETAILS: {
                TITLE: 'Smluvní údaje',
                FIELDS: {
                  CONTRACT_TYPE: 'Typ pracovního poměru',
                  WORK_POSITION: 'Pracovní pozice',
                  VALID_FROM: 'Začátek smlouvy',
                  VALID_TO: 'Konec smlouvy',
                  TRIAL_PERIOD_END_DATE: 'Konec zkušební doby',
                  FTE: 'Pracovní úvazek',
                  LEVEL_OF_EMPLOYMENT_MONTHLY_HOURS: 'Maximální roční hodinový rozsah',
                  WORK_DEPARTMENT: 'Oddělení',
                  PLACE_OF_WORK: 'Místo výkonu práce',
                },
                FTE_WEEK_HOURS: 'h / týden',
              },
              WORKING_HOURS_SCHEDULE: {
                TITLE: 'Rozvržení pracovní doby',
                FIELDS: {
                  DAY_OF_WEEK: 'Den',
                  WORK_FROM: 'Pracovní doba od',
                  WORK_TO: 'Pracovní doba do',
                  BREAK_FROM: 'Přestávka od',
                  BREAK_TO: 'Přestávka do',
                  SUM: 'Celkem',
                },
                COPY: {
                  TOOLTIP: 'Překopírovat pracovní dobu',
                  TITLE: 'Vybrat dny k překopírování',
                  DESCRIPTION: 'Vyberte, pro které dny má dojít k překopírovaní údajů.',
                },
                TOTAL: 'Celkem za týden:',
              },
              TERMINATION: {
                TITLE: 'Ukončení pracovně právního vztahu',
                FIELDS: {
                  TERMINATION_DATE: 'Datum ukončení',
                  TERMINATION_REASON: 'Důvod ukončení',
                },
              },
              TAX_RELIEFS_GENERAL: {
                TITLE: 'Slevy na dani',
                FIELDS: {
                  APPLIES_TAX_PAYER_DECLARATION: 'Sleva na poplatníka',
                  APPLIES_DISABILITY_1_OR_2_DEGREE: 'Sleva invalidita I. a II.',
                  APPLIES_DISABILITY_3_DEGREE: 'Sleva invalidita III.',
                  APPLIES_ZTPP: 'Sleva ZTP/P',
                },
              },
              TAX_RELIEFS_CHILDREN: {
                TITLE: 'Slevy na děti',
                FIELDS: {
                  LAST_NAME: 'Příjmení',
                  FIRST_NAME: 'Jméno',
                  BIRTH_DATE: 'Datum narození',
                  BIRTH_NUMBER: 'Rodné číslo',
                  RELATIONSHIP: 'Vztah',
                  APPLY: 'Uplatnit slevu',
                },
                TABLE: {
                  REMOVE: {
                    TOOLTIP: 'Odstranit nouzový kontakt',
                    MESSAGE: "Opravdu chcete odstranit nouzový kontakt '{{value}}'?",
                  },
                  ADD: {
                    LABEL: 'Přidat',
                    TOOLTIP: 'Přidat nouzový kontakt',
                  },
                },
              },
              TAX_RELIEFS_SPOUSE: {
                TITLE: 'Sleva na manžela/ku',
                FIELDS: {
                  LAST_NAME: 'Příjmení',
                  FIRST_NAME: 'Jméno',
                  BIRTH_NUMBER: 'Rodné číslo',
                  APPLY: 'Uplatnit slevu',
                },
              },
              TAX_RELIEFS_OTHER_BREADWINNER: {
                TITLE: 'Sleva na jinou vyživující osobu',
                FIELDS: {
                  LAST_NAME: 'Příjmení',
                  FIRST_NAME: 'Jméno',
                  BIRTH_NUMBER: 'Rodné číslo',
                  IS_PROVIDING_CHILDREN: 'Vyživuje děti ve společné domácnosti',
                },
              },
              WORK_PROJECT_BREAKDOWN: {
                TITLE: 'Rozdělení smlouvy napříč projekty',
                FIELDS: {
                  PROJECT: 'Projekt',
                  LEVEL_PERCENTAGE: 'Pracovní úvazek',
                  LEVEL_MONTHLY_HOURS: 'Maximální roční hodinový rozsah',
                },
                TABLE: {
                  REMOVE: {
                    TOOLTIP: 'Odstranit rozdělení smlouvy v projektu',
                    MESSAGE: 'Opravdu chcete odstranit rozdělení smlouvy v projektu?',
                  },
                  ADD: {
                    LABEL: 'Přidat',
                    TOOLTIP: 'Přidat projekt',
                  },
                },
              },
              SOCIAL_SERVICE_BREAKDOWN: {
                TITLE: 'Rozdělení smlouvy napříč sociální službami',
                FIELDS: {
                  SOCIAL_SERVICE: 'Sociální služba',
                  LEVEL_PERCENTAGE: 'Pracovní úvazek',
                  LEVEL_MONTHLY_HOURS: 'Maximální roční hodinový rozsah',
                },
                TABLE: {
                  REMOVE: {
                    TOOLTIP: 'Odstranit rozdělení smlouvy v sociální službě',
                    MESSAGE: 'Opravdu chcete odstranit rozdělení smlouvy v sociální službě?',
                  },
                  ADD: {
                    LABEL: 'Přidat',
                    TOOLTIP: 'Přidat sociální službu',
                  },
                },
              },
            },
          },
        },
        EDUCATION: {
          TAB: {
            TITLE: 'Vzdělání',
          },
          SECTIONS: {
            EDUCATIONAL_ATTAINMENT: {
              TITLE: 'Vzdělání',
              FIELDS: {
                EDUCATIONAL_ATTAINMENT: 'Dosažené vzdělání',
                END_YEAR: 'Rok ukončení',
              },
            },
            ACHIEVED_QUALIFICATIONS: {
              TITLE: 'Dosažená kvalifikace',
              FIELDS: {
                HAS_TRAINING_AS_WORKER_IN_SOCIAL_SERVICES: 'Pracovník v sociálních službách (PSS)',
                HAS_TRAINING_AS_SOCIAL_WORKER: 'Sociální pracovník (SP)',
              },
            },
            QUALIFICATIONS: {
              TITLE: 'Vzdělávání v sociálních službách',
              FIELDS: {
                NAME: 'Název',
                REALIZATOR: 'Realizátor',
                TYPE: 'Typ',
                DURATION_MINUTES: 'Délka [min]',
                DURATION_HOURS: 'Délka [hod]',
                YEAR: 'Rok certifikace',
                NOTE: 'Poznámka',
              },
              TABLE: {
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat odbornou kvalifikaci',
                },
                REMOVE: {
                  TOOLTIP: 'Odstranit odbornou kvalifikaci',
                  MESSAGE: "Opravdu chcete odstranit odbornou kvalifikaci '{{value}}'?",
                },
                COURSE_TYPE_SELECT_INFO: {
                  TOOLTIP: 'Detailní informace o typu kurzu',
                  HEADER: 'Detailní informace o typu kurzu',
                  FIELDS: {
                    NAME: 'Název',
                    DESCRIPTION: 'Popis',
                    WORK_POSITIONS: 'Povolené pracovní pozice',
                  },
                },
              },
            },
            DRIVER_LICENCES: {
              TITLE: 'Řidičské průkazy',
              FIELDS: {
                TYPE: 'Typ',
                EXPIRATION_DATE: 'Konec platnosti',
              },
              TABLE: {
                ADD: {
                  LABEL: 'Přidat',
                  TOOLTIP: 'Přidat řidičský průkaz',
                },
                REMOVE: {
                  TOOLTIP: 'Odstranit řidičský průkaz',
                  MESSAGE: "Opravdu chcete odstranit řidičský průkaz '{{value}}'?",
                },
              },
            },
          },
        },
        OTHER: {
          TAB: {
            TITLE: 'Ostatní',
          },
          SECTIONS: {
            MATERNITY_PARENTAL_LEAVE: {
              TITLE: 'Mateřská / Rodičovská dovolená',
              FIELDS: {
                MATERNITY_LEAVE_START_DATE: 'Nástup na MD',
                MATERNITY_LEAVE_END_DATE: 'Konec MD',
                PARENTAL_LEAVE_START_DATE: 'Nástup na RD',
                PARENTAL_LEAVE_END_DATE: 'Konec RD',
                PARENTAL_LEAVE_EXTENSION_TO_DATE: 'Prodloužení RD do',
                EARLY_START_DATE: 'Předčasný nástup',
              },
            },
          },
        },
      },
    },
  },
  EVENT_EDITOR: {
    TITLE: 'Asistence: {{clientName}}',
    EDIT_MODE: 'Režim úprav',
    SAVE: 'ULOŽIT',
    SAVE_AND_CLOSE: 'ULOŽIT A ZAVŘÍT',
    VIEW: 'ZOBRAZIT',
    CREATE_TEMPLATE: 'VYTVOŘIT ŠABLONU',
    DUPLICATE: 'DUPLIKOVAT',
    DELETE: 'SMAZAT',
    CREATE: 'Vytvořit událost',
    UPDATE: 'Upravit událost',
    DEFAULT_EVENT_TYPE: 'Událost',
    DELETE_CONFIRMATION_HEADER: 'Smazat událost',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tuto událost? Tato akce je nevratná.',
    SELECT_CLIENTS: 'Vyberte klienty',
    MAX_CLIENTS_SELECTED: 'Dosažen maximální počet klientů',
    ADD_MORE_CLIENTS: 'Přidat další klienty',
    UNKNOWN_CLIENT: 'Neznámý klient',
    NO_CLIENT_SELECTED: 'Žádný klient nevybrán',
    CLIENT_SELECTED: 'Klient vybrán',
    CLIENTS_SELECTED: 'Klienti vybráni',
    NO_CLIENTS_FOUND: 'Žádní klienti nenalezeni',
    CLIENT_SELECTION: 'Výběr klientů',
    CLIENT_SELECTION_SINGLE: 'Výběr klienta',
    ANONYMOUS_CLIENT: 'Anonymní klient',
    UNLIMITED: 'Neomezeně',
    CLIENT_SELECT: {
      SELECT_CLIENT: 'Vyberte klienta',
      MAX_SELECTION: 'Maximálně {{count}} klientů',
      SINGLE_SELECTION: 'Vyberte pouze jednoho klienta',
    },
    WORKER_SELECTION: 'Výběr pracovníků',
    WORKER_SELECTION_SINGLE: 'Výběr pracovníka',
    WORKER_AVAILABLE: 'Dostupný',
    WORKER_UNAVAILABLE: 'Nedostupný',
    PLANNED_DATES: 'Plánované datumy',
    REALIZED_DATES: 'Realizované datumy',
    SELECT_DATE_TIME: 'Vyberte datum a čas',
    WORKER_NPSK: 'Nepřímá práce související s klientem (min)',
    WORKER_SELECT: {
      LABEL: 'Pracovník',
      ERROR_LOADING: 'Chyba při načítání pracovníků',
      SEARCH: 'Hledat',
      SELECT_AND_CLOSE: 'Zvolit a zavřít',
      SHOW_ALL_WORKERS: 'Zobrazit všechny pracovníky',
      TITLE: 'Dostupní pracovníci',
      TITLE_SINGLE: 'Dostupný pracovník',
      LOADING: 'Načítání pracovníků...',
      SELECT_WORKER: 'Vyberte pracovníka',
      SELECTED_COUNT: 'Vybráno: {{count}}',
      MAX_SELECTION: 'Maximálně {{count}} pracovníků',
      SINGLE_SELECTION: 'Vyberte pouze jednoho pracovníka',
    },
    BASIC: 'Základní',
    CLIENT: 'Klient',
    CLIENT_SEARCH_PLACEHOLDER: 'Zadejte jméno klienta...',
    SELECT_CLIENT: 'Vyberte klienta',
    SELECT_CLIENT_SINGLE: 'Vyberte klienta',
    SELECT_BUTTON_TEXT: 'Zvolit',
    CLOSE: 'Zavřít',
    ASSISTANT: 'Pracovník',
    TRANSIT_TIME: 'přejezd',
    MINUTES: 'min',
    PLANNED_FROM: 'Plánovaná od',
    PLANNED_TO: 'Plánovaná do',
    REALIZED_FROM: 'Reálně od',
    REALIZED_TO: 'Reálně do',
    RECURRENCE: 'Opakování',
    RECURRENCE_SETTINGS: 'Nastavení opakování',
    TOOLTIPS: {
      SAVE: 'Uloží změny bez zavření.',
      SAVE_AND_CLOSE: 'Uloží změny a zavře editor.',
      VIEW: 'Zobrazí detail události.',
      CREATE_TEMPLATE: 'Vytvoří šablonu z této události.',
      DUPLICATE: 'Duplikuje tuto událost.',
      DELETE: 'Smaže tuto událost.',
    },
    PARAMETERS: 'Parametry',
    SLEEPOVER: 'Sleva',
    PREFERRED_ASSISTANT_GENDER: 'Preferované pohlaví pracovníka',
    MALE: 'Muž',
    FEMALE: 'Žena',
    STRONG_ASSISTANT_NEEDED: 'Vyžaduje silného',
    ADVANCED_ASSISTANT_NEEDED: 'Vyžaduje pokročilého',
    NOT_TO_BE_PRIMARILY_ASSIGNED: 'Primárně neobsazovat',
    LATE_ORDER: 'Pozdě objednaná',
    PAID_INTERNALLY: 'Placeno organizací',
    NON_CLIENT_WORK: 'Nepřímá práce',
    SENT_TO_CLIENT: 'Odesláno klientovi',
    SHOW_IN_EXCHANGE: 'Zobrazovat na burze',
    PERFORMANCE_TYPE: 'Typ výkonu',
    ASSISTANT_SELECTION_REQUIRES_DATES: 'Pro výběr pracovníka je potřeba nejdříve vybrat Plánovaná od a Plánovaná do',

    // Validation messages
    VALIDATION: {
      PLANNED_FROM_REQUIRED: 'Plánovaná od je povinná',
      PLANNED_TO_REQUIRED: 'Plánovaná do je povinná',
      PLANNED_TO_BEFORE_FROM: 'Plánovaná do musí být po Plánovaná od',
      REALIZED_TO_BEFORE_FROM: 'Reálně do musí být po Reálně od',
      TITLE_REQUIRED: 'Nadpis je povinný',
      PERFORMANCE_TYPE_REQUIRED: 'Typ výkonu je povinný',
      TAG_REQUIRED: 'Je nutné označit text alespoň jednou značkou',

      // Extended validation messages
      TYPE_OF_CONTACT_REQUIRED: 'Typ kontaktu je povinný',
      CLIENT_REQUIRED: 'Klient je povinný',
      WORKER_REQUIRED: 'Pracovník je povinný',
      TITLE_MIN_LENGTH: 'Název musí mít alespoň {minLength} znaků',
      TITLE_MAX_LENGTH: 'Název může mít maximálně {maxLength} znaků',
      CLIENT_MIN_ARRAY_LENGTH: 'Musíte vybrat alespoň {minArrayLength} klienta',
      MIN_CLIENTS_REQUIRED: 'Vyberte alespoň {{count}} klienta',
      MAX_CLIENTS_EXCEEDED: 'Překročen maximální počet {{count}} klientů',
      MIN_WORKERS_REQUIRED: 'Vyberte alespoň {{count}} pracovníka',
      MAX_WORKERS_EXCEEDED: 'Překročen maximální počet {{count}} pracovníků',
      UNAVAILABLE_WORKERS_WARNING: 'Někteří vybraní pracovníci nejsou dostupní v plánovaném čase',
      CLIENT_MAX_ARRAY_LENGTH: 'Můžete vybrat maximálně {maxCount} klientů',
      WORKER_MIN_ARRAY_LENGTH: 'Musíte vybrat alespoň {minArrayLength} pracovníka',
      WORKER_MAX_ARRAY_LENGTH: 'Můžete vybrat maximálně {maxCount} pracovníků',
      DATE_RANGE_INVALID: 'Plánované datum do musí být po plánovaném datu od',
      DATE_RANGE_OVERLAP: 'Datumy se překrývají s existujícím eventem',
      CUSTOM_INVALID: 'Hodnota neprošla vlastní validací',
      PATTERN_INVALID: 'Hodnota má neplatný formát',
      ENTER_NOTES_PLACEHOLDER: 'Zadejte zápis...',
      UNSUPPORTED_EVENT_TYPE: 'Nepodporovaný typ události',
    },

    // SR Event Editor
    SR_EVENT: {
      CONTENT: 'Obsah',
      CONTACT_TYPE: 'Typ kontaktu',
      SELECT_CONTACT_TYPE: 'Vyberte typ',
      TITLE: 'Nadpis',
      DESCRIPTION: 'Popis',
      NOTES: 'Zápis',
      INSERT_TAG: 'Vložit značku',
      NO_TAGS: 'Žádné značky',
      CLIENT_JOURNAL_ENTRIES: 'Zápisy klientů',
      DELETE_CLIENT_HEADER: 'Smazat klienta',
      DELETE_CLIENT_MESSAGE: 'Klient má vyplněný zápis. Opravdu chcete klienta odstranit?',
      DELETE_CLIENT_CANCEL: 'Zrušit',
      DELETE_CLIENT_CONFIRM: 'Smazat',
      VALIDATION: {
        NO_TAGS: 'Je nutné označit text alespoň jednou značkou',
      },
    },

    // Leave Event Editor
    LEAVE_EVENT: {
      CONTENT: 'Obsah',
      LEAVE_TYPE: 'Typ nepřítomnosti',
      SELECT_LEAVE_TYPE: 'Vyberte typ',
      DESCRIPTION: 'Popis',
      VALIDATION: {
        LEAVE_TYPE_REQUIRED: 'Typ nepřítomnosti je povinný',
        MAX_DURATION: 'Nepřítomnost nesmí být delší než 363 dní',
        WORKER_REQUIRED: 'Pracovník je povinný',
      },
    },
    INDIRECT_WORK_EVENT: {
      CONTENT: 'Obsah',
      WORK_TYPE: 'Typ nepřímé práce',
      SELECT_WORK_TYPE: 'Vyberte typ',
      NAME: 'Název',
      DESCRIPTION: 'Popis',
      DURATION_MINUTES: 'Délka (minuty)',
      REALIZATOR: 'Realizátor',
      ADDRESS: 'Místo',
      VALIDATION: {
        WORK_TYPE_REQUIRED: 'Typ nepřímé práce je povinný',
        NAME_REQUIRED: 'Název je povinný',
        DURATION_REQUIRED: 'Délka je povinná a musí být alespoň 1 minuta',
      },
    },

    CLIENT_RECORDS: 'Záznamy klientů',

    // Common actions
    UNSUPPORTED_EVENT_TYPE: 'Nepodporovaný typ události',
    UNSUPPORTED_EVENT_TYPE_MESSAGE:
      'Pro tento typ události není k dispozici specifický editor. Používají se pouze základní nastavení.',
  },
  PERFORMANCE_LIST: {
    TITLE: 'Seznam výkonů',
    CALENDAR_TOOLTIP: 'Přejít na kalendář výkonů',
    LIST_TOOLTIP: 'Zobrazit seznam výkonů',
    MENU_TOOLTIP: 'Otevřít menu',
    NOTIFY_ASSISTANTS:
      'Je třeba upozornit pracovníky na změny v potvrzených asistencích v příštím týdnu ({{nextWeekDates}}).',
    LOADING: 'Načítání...',
    TABLE: {
      HEADERS: {
        title: 'Název',
        plannedFrom: 'Datum výkonu',
        duration: 'Délka [h:m]',
        clients: 'Klienti',
        workers: 'Pracovníci',
        typeOfContact: 'Typ kontaktu',
        workType: 'Typ výkonu',
      },
    },
  },
  PERFORMANCE_LIST_TOOLBAR: {
    NEW_PERFORMANCE_TOOLTIP: 'Přidat nový výkon',
    SR_EVENT_TOOLTIP: 'Vytvořit individuální výkon',
    SR_GROUP_EVENT_TOOLTIP: 'Vytvořit skupinový výkon',
    IMPORT_TOOLTIP: 'Importovat výkony',
    EXPORT_TOOLTIP: 'Exportovat výkony',
    TEMPLATE_TOOLTIP: 'Zobrazit šablony výkonů',

    // Button text
    NEW_PERFORMANCE: 'Nový výkon',

    // Popover headers
    SELECT_PERFORMANCE_TYPE: 'Vyberte typ výkonu',
    QUICK_ACTIONS: 'Rychlé akce',

    // Event types
    SR_EVENT: 'SR Výkon',
    SR_GROUP_EVENT: 'SR Skupinový výkon',
    INDIVIDUAL_PERFORMANCE: 'Individuální výkon',
    GROUP_PERFORMANCE: 'Skupinový výkon',

    // Quick actions
    IMPORT_PERFORMANCES: 'Import výkonů',
    EXPORT_PERFORMANCES: 'Export výkonů',
    PERFORMANCE_TEMPLATES: 'Šablony výkonů',
  },
  PERFORMANCE_LIST_PAGE: {
    // Table configuration
    GLOBAL_FILTER_PLACEHOLDER: 'Hledat podle názvu, typu kontaktu, klientů nebo pracovníků...',

    // Column headers
    TITLE: 'Název',
    PERFORMANCE_DATE: 'Datum výkonu',
    HOURS_COUNT: 'Počet hodin',
    CLIENT_NAME: 'Jméno klienta/ů',
    WORKERS: 'Pracovník ',
    CONTACT_TYPE: 'Typ kontaktu',
    WORK_TYPE: 'Typ výkonu',
    ACTIONS: 'Akce',

    // Contact type options
    CONTACT_TYPE_EMAIL: 'E-mail',
    CONTACT_TYPE_PHONE: 'Telefon',
    CONTACT_TYPE_MEETING: 'Schůzka',
    CONTACT_TYPE_ASSISTANCE: 'Asistence',
    CONTACT_TYPE_OTHER: 'Ostatní',

    // Work type options
    WORK_TYPE_PP1: 'PP1',
    WORK_TYPE_PP2: 'PP2',
    WORK_TYPE_NP: 'NP',

    // Action tooltips
    EDIT_TOOLTIP: 'Upravit',

    // Status texts
    STATUS_PLANNED: 'Plánovaná',
    STATUS_IN_PROGRESS: 'Probíhá',
    STATUS_COMPLETED: 'Dokončená',
    STATUS_CANCELLED: 'Zrušená',
    STATUS_UNKNOWN: 'Neznámý',

    // Messages
    ERROR_LOADING_EVENTS: 'Chyba při načítání událostí',
    EVENT_UPDATED_SUCCESS: 'Event updated successfully, refreshing list...',
    FAILED_OPEN_MODAL: 'Failed to open edit modal:',
    FILTERS_CHANGED: 'Filters changed in performance list:',
    DATE_RANGE_CHANGED: 'Date range changed in performance list:',
    DEFAULT_DATE_RANGE_SET: 'Default date range set to today:',

    // Default values
    ANONYMOUS_CLIENT: 'anonym',
    UNKNOWN_WORKER: 'neznámý',
    NO_DATA: '-',

    // Debug messages (can be removed in production)
    RAW_EVENTS_RECEIVED: 'Raw events received:',
    CURRENT_DATE_RANGE: 'Current date range:',
    EVENTS_AFTER_FILTERING: 'Events after date filtering:',
    FINAL_EVENTS_COUNT: 'Final events count:',
    EVENT_REFRESH_REQUESTED: 'Event refresh requested - reloading SrEvents',
  },
  SR_EVENT_TABLE: {
    // Table configuration
    CURRENT_PAGE_REPORT_TEMPLATE: 'Zobrazeno {first} až {last} z {totalRecords} záznamů',
    GLOBAL_FILTER_PLACEHOLDER: 'Hledat ve všech sloupcích...',

    // Column headers
    TITLE: 'Název',
    CONTACT_TYPE: 'Typ kontaktu',
    PLANNED_FROM: 'Plánováno od',
    PLANNED_TO: 'Plánováno do',
    REALIZED_FROM: 'Realizováno od',
    REALIZED_TO: 'Realizováno do',
    DESCRIPTION: 'Popis',
    STATUS: 'Stav',
    ACTIONS: 'Akce',

    // Filter placeholders
    SEARCH_TITLE: 'Hledat název...',
    SELECT_CONTACT_TYPE: 'Vybrat typ...',
    FROM_DATE: 'Od data...',
    TO_DATE: 'Do data...',
    SEARCH_DESCRIPTION: 'Hledat v popisu...',
    SELECT_STATUS: 'Vybrat stav...',

    // Action tooltips
    EDIT_EVENT_TOOLTIP: 'Upravit událost',
  },
  TAG_EDITOR: {
    ENTER_NOTES_PLACEHOLDER: 'Zadejte zápis...',
    INSERT_TAG: 'Vložit značku',
    INSERT_TAG_TOOLTIP: 'Vložit značku k označenému textu',
    DEBUG_HTML: 'Debug HTML',
    DEBUG_HTML_TOOLTIP: 'Zkopírovat HTML obsah editoru do schránky',
    SHOW_HTML: 'HTML',
    SHOW_HTML_TOOLTIP: 'Zobrazit HTML obsah pro debugging',
    TEST_CONTENT: 'Test',
    TEST_CONTENT_TOOLTIP: 'Vygenerovat testovací obsah',
    INSERTED_TAGS: 'Vložené značky',
    REMOVE_TAG: 'Odstranit značku',
    SEARCH_TAGS: 'Hledat značky...',
    NO_RECORDS_TITLE: 'Žádné záznamy',
    NO_RECORDS_MESSAGE: 'Klient není zařazen v žádném programu. Zařadit jej můžete',
    NO_RECORDS_LINK: 'zde',
    GO_TO_IP_JOURNAL: 'Přejít na IP deník',
    VALIDATION: {
      TAG_REQUIRED: 'Je nutné označit text alespoň jednou značkou',
    },
    TOOLBAR: {
      BOLD: 'Tučné',
      ITALIC: 'Kurzíva',
      UNDERLINE: 'Podtržení',
      ORDERED_LIST: 'Číslovaný seznam',
      BULLET_LIST: 'Odrážkový seznam',
      INSERT_LINK: 'Vložit odkaz',
      REMOVE_FORMATTING: 'Odstranit formátování',
    },
    PLACEHOLDER: 'Začněte psát...',
    NO_TEXT_SELECTED: 'Nebyl označen žádný text.',
    URL_PROMPT: 'Zadejte URL:',
    REFRESH_TAGS: 'Aktualizovat seznam značek',
  },
  TABLE: {
    ACTION_COLUMN_TITLE: 'Akce',
    EMPTY_DATA_MESSAGE: 'Žádné záznamy nebyly nalezeny',
    EMPTY_CONTENT_TEMPLATE: 'Žádná šablona sbalitelného obsahu nebyla nalezena',
    SUMMARY_TOTAL: 'Počet záznamů: ',
    REMOVE_TABLE_FILTERS: 'Smazat tabulkové filtry',
    currentPageReportTemplate: 'Zobrazeno {first} až {last} z {totalRecords} záznamů',
    COLUMNS_SETTINGS: {
      TOOLTIP: 'Nastavení sloupců',
      TITLE: 'Nastavení sloupců',
      DESCRIPTION: 'Vyberte sloupce, které chcete zobrazit v tabulce.',
      SELECT_ALL: 'Vybrat vše',
      ACTIONS: {
        CANCEL: 'Zrušit',
        SAVE: 'Uložit',
      },
    },
    SELECT_ROWS_MODE_BUTTONS: {
      SELECT_ITEMS: {
        LABEL: 'Vybrat záznamy',
      },
      CANCEL_SELECT_ITEMS: {
        LABEL: 'Zrušit výběr',
      },
    },
  },
  CLIENT_IP_LIST: {
    TREE_NAME: 'Stromová struktura IP',
    TREE: {
      COPY_STRUCTURE_TO_OTHER_CLIENTS: 'Kopírovat k jinému klientovi',
      ADD: {
        PROGRAM_ENROLLMENT_ADD_TOOLTIP: 'Přidat zařazení do programu',
        INDIVIDUAL_PLAN_ADD_TOOLTIP: 'Přidat individuální plán',
        GOAL_ADD_TOOLTIP: 'Přidat cíl',
        STEP_ADD_TOOLTIP: 'Přidat krok',
      },
      COMPLETED: {
        PROGRAM_ARCHIVED_TOOLTIP: 'Program byl archivován',
        PROGRAM_ENROLLMENT_TERMINATED_TOOLTIP: 'Zařazení do programu bylo ukončeno',
        INDIVIDUAL_PLAN_CLOSED_TOOLTIP: 'Individuální plán byl archivován',
        GOAL_COMPLETED_TOOLTIP: 'Cíl byl splněn',
        STEP_COMPLETED_TOOLTIP: 'Krok byl splněn',
      },
    },
    SETTING_TREE: {
      EXPAND_ALL_TOOLTIP: 'Rozbalit vše',
      COLLAPSE_ALL_TOOLTIP: 'Zabalit vše',
      SETTING_ICON_TOOLTIP: 'Nastavení',
      CANCEL_SETTINGS_TOOLTIP: 'Zrušit úpravy výběru',
    },
    SETTING_MODAL: {
      TITLE: 'Upravit nastavení',
      SHOW_CLOSED_IP: 'I archivované IP',
      SHOW_ARCHIVED_PROGRAMS: 'I archivované programy',
      SHOW_ARCHIVED_PROGRAMS_ENROLLMENTS: 'I ukončená zařazení do programů',
      SHOW_COMPLETED_GOALS: 'I splněné cíle',
      SHOW_COMPLETED_STEPS: 'I splněné kroky',
      DUE_DATE: 'Období splatnosti maximálně do',
      APPLY_SETTINGS: 'Aplikovat',
      RESET_SETTINGS: 'Resetovat',
    },
    JOURNAL_ENTRY_MODAL: {
      TITLE: { ADD: 'Přidat deníkový záznam nevázaný na událost', EDIT: 'Upravit deníkový záznam' },
    },
    JOURNAL_ENTRY_EVENT_MODAL: {
      ERROR_OPEN:
        'Nepovedlo se otevřit okno s informacemi události. Otevírá se okno s přímou úpravou deníkového záznamu.',
    },
    JOURNAL_ENTRIES_TABLE: {
      HEADERS: {
        TAG: 'Značky',
        TITLE: 'Název',
        AUTHOR_FULL_NAME: 'Autor',
        IMPORTANCE: 'Důležitost',
        DATE: 'Datum',
        JOURNAL_ENTRY_TYPE: 'Typ záznamu',
        EVENT_DURATION: 'Délka [h:m]',
        EVENT_WORKERS_FULL_NAMES: 'Pracovníci',
        ACTIONS: {
          EDIT: 'Editovat deníkový záznam',
          EDIT_CARE_ACT: 'Upravit úkon výkonu',
          DELETE: 'Smazat deníkový záznam',
        },
      },
      DELETE_CONFIRM_DIALOG: {
        HEADER: 'Smazat deníkový záznam',
        MESSAGE: 'Opravdu chcete smazat tento deníkový záznam?',
      },
      JOURNAL_ENTRY_TYPES: {
        EVENT_ENTRY: 'Zápis',
        JOURNAL_ENTRY: 'Deník',
        CARE_ACT: 'Úkon',
      },
      COLLAPSIBLE: {
        ERROR_LOAD: 'Nepovedl se načíst text deníkového záznamu',
        ERROR_SUBMIT: 'Nepovedlo se uložit upravený text deníku.',
        SUCCESS_SUBMIT: 'Formulář úspěšně odeslán.',
      },
      TOOLBAR: {
        ADD_NEW_JOURNAL_ENTRY: 'Přidat deníkový záznam',
      },
      CARE_LOGS_MODAL: {
        TITLE: 'Úprava úkonu',
        CARE_TYPE: 'Typ úkonu',
        CARE_TYPE_PLACEHOLDER: 'Vyberte typ úkonu',
        DURATION: 'Délka (min)',
        SAVE: 'Uložit',
        DELETE: 'Smazat',
        CANCEL: 'Zrušit',
        CONFIRM_DELETE: 'Opravdu chcete úkon smazat?',
        SUCCESS_SAVE: 'Úkon byl úspěšně uložen.',
        SUCCESS_DELETE: 'Úkon byl úspěšně smazán.',
        ERROR_LOAD: 'Úkon se nepodařilo načíst.',
        ERROR_SAVE: 'Úkon se nepodařilo uložit. Je buď delší než trvání asistence nebo ještě asistence nezačala.',
        ERROR_DELETE: 'Úkon se nepodařilo smazat.',
        ERROR_MISSING_ID: 'Nepodařilo se určit záznam úkonu.',
        CURRENT_CARE_TYPE: 'Aktuální typ úkonu',
      },
    },
  },
  JOURNAL_ENTRY_FORM: {
    TITLE: { ADD: 'Přidat deníkový záznam nevázaný na událost', EDIT: 'Upravit deníkový záznam' },
    LABELS: {
      DATE_TIME: 'Datum a čas',
      IMPORTANCE: 'Důležitost',
      TITLE: 'Nadpis',
      CONTENT: 'Text',
    },
    SUBMIT_BTN: {
      EDIT: 'Uložit',
      ADD: 'Uložit',
    },
    ERROR_SUBMIT: 'Nepovedlo se uložit deníkový záznam',
    SUCCESS_SUBMIT: 'Deníkový záznam byl úspěšně uložen',
  },
  CLIENT_IP_COLLAPSIBLE_CONTENT: {
    STEP: {
      TITLE: 'Krok',
    },
    GOAL: {
      TITLE: 'Cíl',
    },
    INDIVIDUAL_PLAN: {
      TITLE: 'Individuální plán',
    },
    PROGRAM_ENROLLMENT: {
      TITLE: 'Zařazení do programu',
    },
  },
  STEP_EDITOR: {
    TITLE_CREATE: 'Přidat krok',
    TITLE_EDIT: 'Upravit krok',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název kroku',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Krok úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání kroku',
    },
  },
  GOAL_EDITOR: {
    TITLE_CREATE: 'Přidat cíl',
    TITLE_EDIT: 'Upravit cíl',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název cíle',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Cíl úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání cíle',
    },
  },
  INDIVIDUAL_PLAN_EDITOR: {
    TITLE_CREATE: 'Přidat individuální plán',
    TITLE_EDIT: 'Upravit individuální plán',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      NAME: 'Jméno',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Datum do kdy má být splněno',
      DESCRIPTION: 'Popis',
      CONTRACTED_GOAL: 'Smluvený cíl',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název individuálního plánu',
      CRITERION: 'Zadejte kritérium splnění',
      DUE_DATE: 'Vyberte datum',
      DESCRIPTION: 'Zapište popis',
      CONTRACTED_GOAL: 'Zadejte cíl',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
    },
    TOAST: {
      SAVE_SUCCESS: 'Individuální plán úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání individuálního plánu',
    },
  },
  PROGRAM_ENROLLMENT_EDITOR: {
    TITLE_CREATE: 'Přidat zařazení do programu',
    TITLE_EDIT: 'Upravit zařazení do programu',
    PARENT_PROGRAM_LABEL: 'Spadá do programu:',
    FIELDS: {
      PROGRAM: 'Program',
      WAITING_LIST_START_DATE: 'Datum zahájení čekací listiny',
      IS_TERMINATED: 'Ukončeno',
      TERMINATION_REASON: 'Důvod ukončení',
      CONTRACTED_GOAL: 'Smluvený cíl',
    },
    PLACEHOLDER: {
      WAITING_LIST_START_DATE: 'Vyberte datum',
      TERMINATION_REASON: 'Zapište důvod ukončení',
      CONTRACTED_GOAL: 'Zapište smluvený cíl',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      CANCEL: 'Zrušit',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné.',
      DATE_INVALID: 'Neplatné datum.',
      WAITING_LIST_START_DATE_REQUIRED: 'Datum zahájení čekací listiny je povinné.',
    },
    EMPTY_MESSAGES: {
      NO_PROGRAMS_AVAILABLE: 'Žádný program k zařazení',
    },
    TOAST: {
      SAVE_SUCCESS: 'Zařazení do programu úspěšně uloženo',
      SAVE_ERROR: 'Chyba při ukládání zařazení do programu',
    },
  },
  CLIENT_IP_CARD: {
    NO_END_DATE: 'Neurčeno',
    ITEM_TYPE: {
      PROGRAM_ENROLLMENT: 'Zařazení do programu',
      INDIVIDUAL_PLAN: 'Individuální plán',
      GOAL: 'Cíl',
      STEP: 'Krok',
    },
    PROGRAM_ENROLLMENT: {
      DO_EDIT: 'Upravit',
      DO_START: 'Znovu zahájit zařazení',
      DO_TERMINATE: 'Ukončit zařazení',
      DO_DELETE: 'Smazat',
      PROGRAM_DESCRIPTION: 'Popis programu',
      PROGRAM_ARCHIVED_AT: 'Datum archivace programu',
      WAITING_LIST_START_DATE: 'Datum zapsání na čekací listinu',
      IS_TERMINATED: 'Je ukončen',
      TERMINATION_REASON: 'Důvod ukončení',
      DURATIONS: 'Doba trvání zařazení do programu',
      WILL_TERMINATE_ALERT: 'Zařazení do programu {{program}} pro klienta {{client}} bude ukončeno.',
      WILL_START_ALERT: 'Zařazení do programu {{program}} pro klienta {{client}} bude znovu zahájeno.',
      WILL_DELETE_ALERT: 'Zápis programu {{program}} pro klienta {{client}} bude trvale smazán.',
    },
    INDIVIDUAL_PLAN: {
      DO_EDIT: 'Upravit',
      DO_OPEN: 'Obnovit z archivu',
      DO_CLOSE: 'Archivovat',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CONTRACTED_GOAL: 'Smluvený cíl',
      DUE_DATE: 'Termín revize',
      CLOSED_AT: 'Datum archivace',
      WILL_CLOSE_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude archivován.',
      WILL_OPEN_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude obnoven z archivu.',
      WILL_DELETE_ALERT: 'Individuální plán {{plan}} programu {{program}} klienta {{client}} bude trvale smazán.',
    },
    GOAL: {
      DO_EDIT: 'Upravit',
      DO_COMPLETE: 'Označit jako splněný',
      DO_UNFULFILL: 'Označit jako nesplěný',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Má být splněno do',
      COMPLETED_AT: 'Splněno',
      WILL_COMPLETE_ALERT: 'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude označen jako splněný.',
      WILL_UNFULFILL_ALERT:
        'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude označen jako nesplněný.',
      WILL_DELETE_ALERT: 'Cíl {{goal}} individuálního plánu {{plan}} klienta {{client}} bude trvale smazán.',
    },
    STEP: {
      DO_EDIT: 'Upravit',
      DO_COMPLETE: 'Označit jako splněný',
      DO_UNFULFILL: 'Označit jako nesplěný',
      DO_DELETE: 'Smazat',
      DESCRIPTION: 'Popis',
      CRITERION: 'Kritérium',
      DUE_DATE: 'Má být splněno do',
      COMPLETED_AT: 'Splněno',
      WILL_COMPLETE_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude označen jako splněný.',
      WILL_UNFULFILL_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude označen jako nesplněný.',
      WILL_DELETE_ALERT: 'Krok {{step}} cíle {{goal}} klienta {{client}} bude trvale smazán.',
    },
  },
  STATISTICS: {
    TITLE: 'Statistiky',
    PERIOD_SELECTION: 'Výběr období',
    DATE_FROM: 'Od',
    DATE_TO: 'Do',
    YEAR: 'Rok',
    MONTH: 'Měsíc',
    REFRESH: 'Aktualizovat',
    CLIENT_STATISTICS: 'Statistiky klientů',
    EMPLOYEE_STATISTICS: 'Statistiky pracovníků',
    CARE_ACTS_STATISTICS: 'Úkony',
    INVALID_DATE_RANGE: 'Datum od nemůže být větší než datum do',
    UNIQUE_CLIENTS: 'unikátních klientů s alespoň jedním výkonem ve zvoleném období',
    ANONYMOUS_CLIENTS_COUNT: 'anonymů ve zvoleném období',
    UNIQUE_EMPLOYEES: 'unikátních zaměstnanců s alespoň jedním výkonem ve zvoleném roce',
    TOTAL_HOURS_CLIENTS: 'celková suma vykázaných hodin za všechny klienty',
    TOTAL_HOURS_EMPLOYEES: 'celková suma odpracovaných hodin všech zaměstnanců',
    INDIVIDUAL: 'Individuální',
    GROUP: 'Skupinová',
    TOTAL: 'Celkem',
    PP1_STATISTICS: 'PP1',
    PP2_STATISTICS: 'PP2',
    NPSK_STATISTICS: 'Nepřímá práce související s klientem',
    NP_STATISTICS: 'Nepřímá práce nesouvisející s klientem',
    PP1_TOTAL: 'PP1 celkem',
    PP2_TOTAL: 'PP2 celkem',
    NP_TOTAL: 'Nepřímá práce nesouvisející s klientem celkem',
    NPSK_TOTAL: 'Nepřímá práce související s klientem celkem',
    WORK_TYPE_BREAKDOWN: 'Rozdělení podle typu práce',
    PP1_INDIVIDUAL: 'PP1 (Individuální)',
    PP2_GROUP: 'PP2 (Skupinové)',
    CLIENT_DETAILS: 'Detailní přehled po klientech',
    EMPLOYEE_DETAILS: 'Detailní přehled po zaměstnancích',
    SHOW_ALL: 'Zobrazit všechny',
    CLIENT: 'Klient',
    HOURS: 'Hodiny (hh:mm)',
    PERFORMANCES: 'Počet výkonů',
    EMPLOYEE: 'Zaměstnanec',
    PP1_HOURS: 'PP1 (h)',
    PP2_HOURS: 'PP2 (h)',
    TOTAL_HOURS: 'Celkem (h)',
    ACTIONS: 'Akce',
    EXPORT_XLS: 'Exportovat do XLS',
    REFRESH_DATA: 'Obnovit data',
    DATA_VALID_TO: 'data validní k',
    SEARCH_CLIENT: 'Hledat klienta...',
    SEARCH_EMPLOYEE: 'Hledat zaměstnance...',
    SEARCH_CARE_ACT_TYPE: 'Hledat typ úkonu...',
    CARE_ACTS_DETAILS: 'Detailní přehled úkonů po klientech',
    CARE_ACTS: 'Úkony (počet, čas)',
    ASSISTANT_NAMES: 'Jméno asistenta',
    SEARCH_CLIENT_OR_EMPLOYEE: 'Hledat v klientských/zaměstnaneckých statistikách...',
    TABLE_HEADERS: {
      CLIENT: 'Klient',
      CLIENTS: 'Klientů',
      EMPLOYEE: 'Zaměstnanec',
      HOURS: 'Hodiny (hh:mm)',
      PERFORMANCES: 'Počet výkonů',
      PP1_HOURS: 'PP1 (h)',
      PP2_HOURS: 'PP2 (h)',
      TOTAL: 'Celkem (h)',
      PP1_INDIVIDUAL_HOURS: 'PP1 individuální (h)',
      PP1_GROUP_HOURS: 'PP1 skupinová (h)',
      PP1_SUM_HOURS: 'PP1 suma (h)',
      PP2_INDIVIDUAL_HOURS: 'PP2 individuální (h)',
      PP2_GROUP_HOURS: 'PP2 skupinová (h)',
      PP2_SUM_HOURS: 'PP2 suma (h)',
      NP_INDIVIDUAL_HOURS: 'Nepřímá práce nesouvisející s klientem individuální (h)',
      NP_GROUP_HOURS: 'Nepřímá práce nesouvisející s klientem skupinová (h)',
      NP_SUM_HOURS: 'Nepřímá práce nesouvisející s klientem suma (h)',
      NPSK_INDIVIDUAL_HOURS: 'Nepřímá práce související s klientem individuální (h)',
      NPSK_GROUP_HOURS: 'Nepřímá práce související s klientem skupinová (h)',
      NPSK_SUM_HOURS: 'Nepřímá práce související s klientem suma (h)',
      // Short labels used as sub-headers in the grouped (double) table header
      PP1: 'PP1',
      PP2: 'PP2',
      NP: 'Nepřímá práce nesouvisející s klientem',
      NPSK: 'Nepřímá práce související s klientem',
      INDIVIDUAL: 'Individuální (h)',
      GROUP: 'Skupinová (h)',
      SUM: 'Suma (h)',
      TOTAL_PP1_PP2_HOURS: 'Suma PP1 + PP2 (h)',
      CARE_ACTS: 'Úkony (počet, čas)',
      ASSISTANT_NAMES: 'Jméno asistenta',
      TOTAL_MINUTES: 'Celkem (h:min)',
    },
    EXPORT_SHEET_NAME_INFO: 'Informace',
    EXPORT_SHEET_NAME_EMPLOYEE: 'Statistiky zaměstnanců',
    EXPORT_SHEET_NAME_CLIENT: 'Statistiky klientů',
    EXPORT_SHEET_NAME_CARE_ACTS: 'Úkony',
    EXPORT_FILE_NAME_PREFIX: 'Statistiky',
    EXPORT_LABEL_PERIOD: 'Období exportu',
    EXPORT_LABEL_FROM: 'Od',
    EXPORT_LABEL_TO: 'Do',
    EXPORT_LABEL_CREATED: 'Vytvořeno',
    EXPORT_ROW_LABEL_SUM: 'Suma',
  },
  PROGRAMS_LIST: {
    TITLE: 'Programy',
    EDIT_TOOLTIP: 'Upravit program',
    LOADING: 'Načítání...',
    TABLE: {
      HEADERS: {
        title: 'Název',
        description: 'Popis',
        socialService: 'Sociální služba',
        archivedAt: 'Datum archivace',
        actions: 'Akce',
      },
    },
  },
  PROGRAM_EDITOR: {
    BASIC: 'Základní',
    TITLE_CREATE: 'Přidat program',
    TITLE_EDIT: 'Upravit program',
    DELETE_CONFIRMATION_HEADER: 'Smazat program',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tento program? Tato akce je nevratná.',
    FIELDS: {
      ARCHIVED_AT: 'Datum archivace',
      DESCRIPTION: 'Popis',
      SOCIAL_SERVICE: 'Sociální služba',
      NAME: 'Název',
    },
    PLACEHOLDER: {
      NAME: 'Zadejte název programu',
      DESCRIPTION: 'Zapište popis',
      SOCIAL_SERVICE: 'Vyberte sociální službu',
    },
    ACTIONS: {
      SAVE: 'Uložit',
      DELETE: 'Smazat',
      ARCHIVE: 'Archivovat',
      UNARCHIVE: 'Aktivovat',
    },
    VALIDATION: {
      REQUIRED: 'Pole je povinné',
    },
    TOAST: {
      SAVE_SUCCESS: 'Program úspěšně uložen',
      SAVE_ERROR: 'Chyba při ukládání programu',
    },
  },
  PROGRAMS_LIST_TOOLBAR: {
    NEW_PROGRAM_TOOLTIP: 'Přidat nový program',
    NEW_PROGRAM: 'Nový program',
  },
  EVENTS_LIST: {
    TITLE: 'Události',
    EDIT_TOOLTIP: 'Upravit událost',
    LOADING: 'Načítání...',
    TABLE: {
      HEADERS: {
        eventTypeName: 'Typ události',
        note: 'Poznámka',
        status: 'Stav',
        plannedFrom: 'Plánováno od',
        plannedTo: 'Plánováno do',
        durationPlanned: 'Délka plánovaná',
        realizedFrom: 'Realizováno od',
        realizedTo: 'Realizováno do',
        durationRealized: 'Délka Realizováno',
        workers: 'Pracovníci',
        clients: 'Klienti',
        actions: 'Akce',
      },
    },
  },
  EVENTS_LIST_TOOLBAR: {
    NEW_EVENT_TOOLTIP: 'Přidat novou událost',
    NEW_EVENT: 'Nová událost',
    SELECT_EVENT_TYPE: 'Vyberte typ události',
    EXCEL_EXPORT: 'Excel export',
    LEAVE_EVENT: 'Nepřítomnost',
    LEAVE_EVENT_DESCRIPTION: 'Vytvořit novou nepřítomnost',
  },
  CONFIG: {
    ORGANIZATION_NAME: 'Název',
    ORGANIZATION_ADDRESS: 'Adresa sídla',
    ORGANIZATION_PHONE: 'Telefon',
    ORGANIZATION_ID_NUMBER: 'IČO',
    ORGANIZATION_BANK_ACCOUNT_NUMBER: 'Číslo účtu',
    ORGANIZATION_BANK_NAME: 'Název banky',
    ORGANIZATION_BANK_ADDRESS: 'Adresa banky',
    JOURNAL_ENTRY_HISTORY_TITLE: 'Deníkové záznamy',
    JOURNAL_ENTRY_HISTORY_SHOW_HISTORY: 'Zobrazit historii zápisů z jiných asistencí v roli asistenta',
  },

  IP_JOURNAL_COPY_EDITOR: {
    TITLE: 'Kopírovat IP k jinému klientovi',
    STRUCTURE_CHOOSE_TITLE: 'IP',
    COPY_BUTTON: 'Kopírovat',
    TOAST: {
      SAVE_SUCCESS: 'IP úspěšně zkopírován',
      SAVE_ERROR: 'Chyba při kopírování IP',
    },
    VALIDATION: {
      CLIENT_REQUIRED: 'Klient je povinný',
      IP_ENTRIES_REQUIRED: 'Vyberte alespoň jednu položku',
    },
  },
  CALENDAR: {
    BUTTON_HINTS: {
      PREV: 'Předchozí týden',
      NEXT: 'Další týden',
      TODAY: 'Tento týden',
      DAY_VIEW: 'Zobrazení dne',
      WEEK_VIEW: 'Zobrazení týdne',
    },
  },
  USER_LIST: {
    FIRST_NAME: 'Jméno',
    LAST_NAME: 'Příjmení',
    LOGIN: 'Login',
    ROLES: 'Role',
    WORKGROUP: 'Pracovní skupina',
    WORKGROUP_ABBR: 'PS',
    SOCIAL_SERVICE: 'Sociální služba',
    LOCATION: 'Lokace',
    ACTIONS: 'Akce',
    DELETE_CONFIRMATION_HEADER: 'Smazat uživatele',
    DELETE_CONFIRMATION_MESSAGE: 'Opravdu chcete smazat tohoto uživatele?',
  },
  EDIT_USER: {
    EDIT_USER: 'Upravit uživatele',
    CREATE_USER: 'Vytvořit uživatele',
    BASIC_DETAILS: 'Základní údaje',
    PERMISSIONS: 'Oprávnění',
    LOGIN_DETAILS: 'Přihlašovací údaje',
    OTHER: 'Ostatní',
    FIRST_NAME: 'Jméno',
    LAST_NAME: 'Příjmení',
    GENDER: 'Pohlaví',
    BIRTH_DATE: 'Datum narození',
    WORKGROUP: 'Pracovní skupina',
    KEY_COORDINATOR: 'Klíčový koordinátor',
    ASSISTANT_KEY_WORKER: 'Klíčový pracovník asistenta',
    CLIENT_KEY_WORKER: 'Klíčový pracovník klienta',
    KEY_WORKER: 'Klíčový pracovník',
    SELECT_KEY_WORKER: 'Vyberte klíčového pracovníka',
    COORDINATOR_NOT_IN_LOCATION: 'Vybraný koordinátor není dostupný ve zvolených lokacích',
    COORDINATOR_NOT_LOADED_YET: 'Data ještě nebyla načtena',
    EMAIL: 'E-mail',
    PASSWORD: 'Heslo',
    ONLY_IF_CHANGING_PASSWORD: 'pouze pokud jej měníte',
    ENTER_VALID_FIRST_NAME: 'Zadejte jméno',
    ENTER_VALID_LAST_NAME: 'Zadejte příjmení',
    ENTER_VALID_EMAIL: 'Zadejte platný e-mail',
    EMAIL_ALREADY_IN_USE: 'Tento e-mail už používá jiný uživatel',
    ENTER_VALID_PASSWORD: 'Zadejte platné heslo (alespoň {{minLength}} znaků)',
    ENTER_VALID_BIRTH_DATE: 'Zadejte datum narození',
    BIRTH_DATE_MUST_BE_IN_PAST: 'Datum narození musí být v minulosti',
    SELECT_GENDER: 'Vyberte pohlaví',
    SELECT_WORKGROUP: 'Vyberte pracovní skupinu',
    SELECT_KEY_COORDINATOR: 'Vyberte klíčového koordinátora',
    SAVE_SUCCESSFUL: 'Uživatel uložen',
    SAVE_FAILED: 'Chyba při ukládání uživatele',
  },
  ASSISTANCE_CARE_LOG_EDITOR: {
    TASK: 'Úkon',
    DURATION_MIN: 'Délka (min)',
    ACTION: 'Akce',
    REMOVE: 'Odebrat',
    SELECT_FROM_OFFER: 'Vyberte z nabídky úkonů',
    NO_TASKS: 'Žádné úkony',
    CLOSE: 'Zavřít',
    ADD: 'Přidat',
    TOTAL_MINUTES: 'minut celkem',
    TOTAL: 'Celkem',
    REMAINING_MINUTES: 'Zbývající čas',
    ERROR_ZERO: 'Délka úkonu nesmí být 0',
    ERROR_EXCEEDS: 'Celkový součet úkonů by překročil délku asistence',
    MY_JOURNAL_ENTRY: 'Můj deníkový zápis',
    SAVE_ENTRY: 'Uložit zápis',
    TASKS: 'Úkony',
    HIDE_TASKS: 'Skrýt úkony',
    SHOW_TASKS: 'Zobrazit úkony',
    ERROR_LOAD_CARE_TYPES: 'Nepodařilo se načíst typy úkonů.',
    TOAST_ENTRY_SAVED: 'Zápis byl uložen',
    TOAST_ENTRY_SAVE_FAILED: 'Nepodařilo se uložit zápis.',
    REMOVE_ENTRY_WITH_DURATION_CONFIRM_HEADER: 'Smazat úkon?',
    REMOVE_ENTRY_WITH_DURATION_CONFIRM: 'Tento úkon má již zadaný čas. Opravdu smazat?',
    CONFIRM_YES: 'Ano',
    CONFIRM_NO: 'Ne',
    SEARCH: 'Hledat…',
    JOURNAL_ENTRY_HISTORY: 'Historie zápisů',
    JOURNAL_ENTRY_HISTORY_EMPTY: 'Žádné předchozí zápisy',
  },
  ATTENDANCE_REPORT: {
    PAGE_TITLE: 'Výkaz práce',
    TOAST_EXPORT_FAILED: 'Export se nezdařil. Zkuste to prosím znovu.',
    LOAD_ERROR: 'Nepodařilo se načíst výkaz docházky.',
    NO_CONTRACTS: 'Pracovník nemá v zadaném období žádnou platnou smlouvu (PS, DPP, DPC).',
    WORK_POSITION: 'Pracovní pozice',
    DEFAULT_WORKER_NAME: 'Pracovník',
    UNKNOWN_WORKER: 'Neznámý pracovník',
    TOOLTIP_SHOW_TOOLBAR: 'Zobrazit panel nástrojů',
    TOOLTIP_HIDE_TOOLBAR: 'Skrýt panel nástrojů',
    ARIA_PREV_MONTH: 'Předchozí měsíc',
    ARIA_NEXT_MONTH: 'Další měsíc',
    REAL_ATTENDANCE_TITLE: 'Reálná docházka',
    CONTRACT_UVAZEK_FOND: 'Úvazek: {{uvazek}} | Měsíční fond pracovní doby: {{fond}}',
    CONTRACT_NO_WORKLOAD_WARNING: 'Tato smlouva nemá definovaný úvazek',
    CONTRACT_TYPE: {
      PS: 'Pracovní smlouva',
      DPP: 'DPP',
      DPC: 'DPC',
    },
    PLACEHOLDER_TIME: 'HH:MM',
    PLACEHOLDER_HOURS: '00:00',
    VALIDATION_TIME_FROM_BEFORE_TO: 'Čas od musí být menší než čas do',
    CONTRACT_NAME: 'Smlouva {{index}}',
    SHEET_NAME_FALLBACK: 'Smlouva_{{index}}',
    EXPORT_EVIDENCE_LABEL: 'Export Evidence pracovní doby',
    EXPORT_EVIDENCE_DESC: 'Exportuje evidenci docházky',
    EXPORT_COMPLETE_LABEL: 'Export Komplet',
    EXPORT_COMPLETE_DESC: 'Exportuje evidenci docházky i reálnou docházku',
    FILE_NAME_EVIDENCE_PREFIX: 'Evidence-pracovni-doby',
    FILE_NAME_COMPLETE_PREFIX: 'Export-komplet',
    EXPORT: {
      AGG_WORKING_TITLE: 'Agregace – pracovní doba',
      AGG_ABSENCE_TITLE: 'Agregace – absence',
      SHEET_REAL_ATTENDANCE: 'Reálná docházka',
    },
    TOTALS: 'Celkem:',
    AGG_WORKING: {
      MONTHLY_FUND: 'Měsíční pracovní fond',
      WORKED_HOURS: 'Odpr. hodiny',
      STANDBY_FULFILLED: 'Odpr. pohotovost',
      OVERTIME: 'Přesčas (v měsíci)',
      NIGHT: 'Práce noc',
      WEEKEND: 'Práce víkend',
      HOLIDAY: 'Práce svátek',
      STANDBY: 'Pohotovost',
    },
    AGG_REAL: {
      OVERTIME_UNDERTIME: 'Přesčas / nedočas',
      OVERTIME_UNDERTIME_TOOLTIP: 'Součet sloupce vyrovnání',
      ABSENCE_TOTAL: 'Absence celkem',
    },
    ABSENCE: {
      VACATION: 'Dovolená',
      SICKNESS: 'Dočasná pracovní neschopnost',
      SICK_DAY: 'Sick day',
      PAID_LEAVE: 'Placené volno',
      NURSING: 'Ošetřování člena rodiny',
      UNEXCUSED: 'Neomluvená absence',
      UNPAID_LEAVE: 'Neplacené volno',
      OTHER: 'Jiný důvod',
    },
    ABSENCE_AGG: {
      COL_NAME: 'Název absence',
      COL_HOURS: 'h:mm',
      COL_DATES: 'Datum',
      TOTAL: 'Celkem',
    },
    COLUMNS: {
      DATUM: 'Datum',
      DEN: 'Den',
      CAS_OD: 'Čas od',
      CAS_DO: 'Čas do',
      PRESTAVKA: 'Přest. [h]',
      ODPRAC_HODINY: 'Odprac. [h]',
      NOC: 'Noc [h]',
      VIKEND: 'Víkend [h]',
      SVATEK: 'Svátek [h]',
      PRESCAS: 'Přesčas [h]',
      POHOTOVOST: 'Pohot. [h]',
      ODPR_POH: 'Odprac. pohot. [h]',
      POZNAMKA: 'Poznámka',
      ABSENCE: 'Absence',
      ABS_HODINY: 'Abs. [h]',
      PP1: 'PP1',
      PP2: 'PP2',
      NP: 'NP',
      NPSK: 'NPSK',
      SUMA: 'SUMA',
      DOSTUPNOST_HODINY: 'Dostupnost hodiny',
      VYROVNANI: 'Vyrovnání',
      TYP_PRACE: 'Typ práce',
      PRIPLATKY_HODINY: 'příplatky/hodiny',
    },
  },
} as const

// Export the translations for the loader
export const cs = TRANSLATIONS
